export default __webpack_public_path__ + "static/media/gisimage.7cbfc1e3.PNG";